import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Preloader from "./Include/PreLoader";
import AIBackground from "../functions/AIBackground";
import PandaPickLogo from "../assets/icon.png";
import API_URL from "../functions/config";

const Signup = () => {

     useEffect(() => {
            document.body.classList.add("signup");
    
            return () => {
                document.body.classList.remove("signup");
            };
        }, []);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [countryCode, setCountryCode] = useState("+91");
    const [phone, setPhone] = useState("");

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();

    useEffect(() => {

        const auth = localStorage.getItem("user");

        if (auth) {
            navigate("/");
            return;
        }

        const empauth = localStorage.getItem("empuser");

        if (empauth) {
            navigate("/");
        }

    }, [navigate]);


    // Password rules
    const passwordRules = {
        minLength: password.length >= 8,
        number: /[0-9]/.test(password),
        alphabet: /[A-Za-z]/.test(password),
        capital: /[A-Z]/.test(password),
        special: /[@#$%&*!]/.test(password)
    };


    const isPasswordValid =
        passwordRules.minLength &&
        passwordRules.number &&
        passwordRules.alphabet &&
        passwordRules.capital &&
        passwordRules.special;


    // Email validation
    const isEmailValid =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);


    // Phone validation
    const isPhoneValid =
        /^[0-9]{10}$/.test(phone);


    // Submit
    const collectdata = async (e) => {

        e.preventDefault();

        setError("");
        setMessage("");

        // Name
        if (!name.trim()) {
            setError("Please enter your name");
            return;
        }


        // Email
        if (!isEmailValid) {
            setError("Please enter a valid email address");
            return;
        }


        // Phone
        if (!isPhoneValid) {
            setError("Please enter a valid 10 digit phone number");
            return;
        }


        // Password
        if (!isPasswordValid) {
            setError("Please fulfill all password requirements");
            return;
        }


        // Confirm password
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }


        try {

            setLoading(true);

            const result = await fetch(`${API_URL}/register`, {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    name,
                    email,
                    password,
                    phone: `${countryCode}${phone}`
                })

            });


            const data = await result.json();


            if (!result.ok) {

                setError(
                    data.message || "Registration failed"
                );

                return;
            }


            // IMPORTANT:
            // Don't save JWT/user here.
            // User must verify email first.

            setMessage(
                data.message ||
                "Registration successful. Please check your email."
            );


            // Optional: clear form
            setPassword("");
            setConfirmPassword("");


        } catch (error) {

            console.error(error);

            setError(
                "Unable to connect to server. Please try again."
            );

        } finally {

            setLoading(false);
        }
    };


    const Rule = ({ valid, children }) => (

        <div
            style={{
                color: valid ? "green" : "#777",
                fontSize: "14px",
                marginBottom: "4px"
            }}
        >
            {valid ? "✓" : "○"} {children}
        </div>

    );


    return (

        <div className="hero-section">

            <AIBackground />

            <div className="form_box">

                <div className="form-group">

                    <div className="row justify-content-center g-4">

                        <div className="text-center">

                            <img
                                src={PandaPickLogo}
                                alt="PandaPick"
                                className="img-fluid"
                            />

                        </div>

                    </div>


                    <h3 className="text-center">
                        Start Your <b>Smart Journey</b>
                    </h3>

  {loading ? (
                <Preloader show={loading} />
            ) : (
                    <form onSubmit={collectdata}>

                        {/* Name */}

                        <input
                            className="form-field"
                            type="text"
                            value={name}
                            onChange={(e) =>
                                setName(e.target.value)
                            }
                            placeholder="Please Enter Your Name"
                        />


                        {/* Email */}

                        <input
                            className="form-field"
                            autoComplete="off"
                            type="email"
                            value={email}
                            onChange={(e) =>
                                setEmail(e.target.value)
                            }
                            placeholder="Please Enter Your Email"
                        />


                        {/* Country + Phone */}

                        <div className="d-flex gap-2">

                            <select
                                className="form-field"
                                value={countryCode}
                                onChange={(e) =>
                                    setCountryCode(e.target.value)
                                }
                                style={{
                                    width: "100px"
                                }}
                            >

                                <option value="+91">
                                    🇮🇳 +91
                                </option>

                                <option value="+1">
                                    🇺🇸 +1
                                </option>

                                <option value="+44">
                                    🇬🇧 +44
                                </option>

                                <option value="+971">
                                    🇦🇪 +971
                                </option>

                                <option value="+61">
                                    🇦🇺 +61
                                </option>

                                <option value="+65">
                                    🇸🇬 +65
                                </option>

                            </select>


                            <input
                                className="form-field"
                                type="tel"
                                value={phone}
                                onChange={(e) => {

                                    const value =
                                        e.target.value.replace(
                                            /\D/g,
                                            ""
                                        );

                                    if (value.length <= 10) {
                                        setPhone(value);
                                    }

                                }}
                                placeholder="Phone Number"

                                 style={{
                                    width: "100%"
                                }}
                            />

                        </div>


                        {/* Password */}

                        <input
                            className="form-field"
                            autoComplete="off"
                            type="password"
                            value={password}
                            onChange={(e) =>
                                setPassword(e.target.value)
                            }
                            placeholder="Please Enter Your Password"
                        />


                        {/* Password Rules */}

                        <div className="signup_passwordbox">

                        <Rule valid={passwordRules.minLength}>
                            Minimum 8 characters
                        </Rule>

                        <Rule valid={passwordRules.number}>
                            At least 1 number
                        </Rule>

                        <Rule valid={passwordRules.alphabet}>
                            At least 1 alphabet
                        </Rule>

                        <Rule valid={passwordRules.capital}>
                            At least 1 capital letter
                        </Rule>

                        <Rule valid={passwordRules.special}>
                            At least 1 special character (@ # $ % & * !)
                        </Rule>

                </div>


                {/* Confirm Password */}

                <input
                    className="form-field"
                    autoComplete="off"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) =>
                        setConfirmPassword(e.target.value)
                    }
                    placeholder="Confirm Password"
                />


                {/* Confirm password message */}

                {confirmPassword && (

                    <div
                        style={{
                            color:
                                password === confirmPassword
                                    ? "green"
                                    : "red",
                            fontSize: "14px",
                            marginBottom: "10px"
                        }}
                    >

                        {password === confirmPassword
                            ? "✓ Passwords match"
                            : "✕ Passwords do not match"}

                    </div>

                )}


                {/* Error */}

                {error && (

                    <div className="alert p-1 alert-danger">
                        {error}
                    </div>

                )}


                {/* Success */}

                {message && (

                    <div className="alert p-1 alert-success">
                        ✓ {message}
                    </div>

                )}


                <p className="text-black">
                    I agree to the Terms of Service,
                    Privacy Policy, and Use of Cookies
                </p>


                <button
    type="submit"
    className="btn_main"
    disabled={loading}
>
    {loading ? "Creating Account..." : "Sign Up"}
</button>

            </form>

            )}

        </div>

            </div >

        </div >

    );
};

export default Signup;